import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-rlink.component'

import MyRlinkModel from './my-rlink-model'

import RegistrationContactsBlock from '../common/registration-contacts-block'

let module = angular.module('myRlink', [
  uiRouter,
  MyRlinkModel,
  RegistrationContactsBlock
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('registration.myRlink', {
      url: '/my-rlink?civility&lastName&firstName&email&model&friendlyName&vin',
      params: {
        password: null
      },
      component: 'myRlink'
    })
})
.component('myRlink', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/index.js